module.exports = __webpack_public_path__ + "assets/img/home-swiper-dot.6400d120.png";